import 'reflect-metadata';

export * as endpoints from './lib/endpoints';
export { Api } from './lib/api';
export * from './lib/analytics/analytics.interface';
export * from './lib/cash-management';
export * from './lib/feature-flags';
export * from './lib/nursing-home';
export * from './lib/payment';
export * from './lib/reporting';
export * from './lib/resident';
export * from './lib/service-provider';
export * from './lib/transaction';
export * from './lib/user-profile';
export * from './lib/family-member-mobile-app';
export * from './lib/images';
export * from './lib/errors';
export * from './lib/employee';
export * from './lib/tax-configuration';
export {
  type GetAllResidentsResult,
  type ShowResidentDto,
} from './lib/resident-phoenix';

export const headerConstants = {
  lastEventHeader: 'x-last-event-timestamp',
};
export {
  receiptStatusValuesFromString,
  isSettlementReceiptState,
  requiresManualSubmissionReceiptState,
} from './lib/transaction/ReceiptStatusValues';
export {
  ReceiptStatusValues,
  ReceiptState,
} from './lib/transaction/ReceiptStatusValues';

export {
  RecurringItemDto,
  TaxCodeDto,
} from './lib/transaction/receiptBatchDto';
